window.CartService = function () {
  let fetchFun = new window.fetchdata();
  return {
    set: function (data, successCallback, failedCallback) {
      let url = location.origin + "/service/bis/add";
      return fetchFun.fetchData(
        url,
        "POST",
        JSON.stringify(data),
        successCallback,
        failedCallback,
      );
    },
    get: function (data, successCallback, failedCallback) {
      let url = location.origin + "/service/bis/get";
      return fetchFun.fetchData(
        url,
        "GET",
        JSON.stringify(data),
        successCallback,
        failedCallback,
      );
    },
  };
};

window.bis = new window.CartService();
